import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Dashboard from './pages/Dashboard';
import Pedidos from './pages/Pedidos';
import Financeiro from './pages/Financeiro';
import Admin from './pages/Admin';
import Login, { AuthProvider, RequireAuth } from './pages/Login';
import ServicoEditor from './pages/ServicoEditor';
import Configuracoes from './pages/Configuracoes';
import SimularAtendimento from './pages/SimularAtendimento';

import ErrorBoundary from './components/ErrorBoundary';
import TopBar from './components/TopBar';
import BottomNav from './components/BottomNav';

const APP_ROUTES = ['/dashboard', '/pedidos', '/financeiro', '/editor/servicos', '/configuracoes'];

function AppShell() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const location = useLocation();
  const showChrome = APP_ROUTES.some(r => location.pathname.startsWith(r));

  useEffect(() => {
    const handler = () => setUpdateAvailable(true);
    window.addEventListener('sw-updated', handler);
    return () => window.removeEventListener('sw-updated', handler);
  }, []);

  return (
    <div className="App">
      {updateAvailable && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
          background: '#334155', color: 'white', padding: '10px 16px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          fontSize: '0.85rem', fontWeight: 500, fontFamily: 'Inter, sans-serif',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          paddingTop: 'max(10px, env(safe-area-inset-top))'
        }}>
          <span>Nova versao disponivel</span>
          <button onClick={() => window.location.reload()} style={{
            background: 'white', color: '#334155', border: 'none',
            borderRadius: '6px', padding: '6px 14px', fontWeight: 700,
            fontSize: '0.8rem', cursor: 'pointer'
          }}>Atualizar</button>
        </div>
      )}
      {showChrome && <TopBar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/entrar" element={<Login />} />

        <Route path="/dashboard"  element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="/pedidos"    element={<RequireAuth><Pedidos /></RequireAuth>} />
        <Route path="/financeiro"     element={<RequireAuth><Financeiro /></RequireAuth>} />
        <Route path="/editor/servicos" element={<RequireAuth><ServicoEditor /></RequireAuth>} />
        <Route path="/configuracoes"  element={<RequireAuth><Configuracoes /></RequireAuth>} />
        <Route path="/simular-atendimento" element={<RequireAuth><SimularAtendimento /></RequireAuth>} />

        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {showChrome && <BottomNav />}

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#ffffff',
            color: '#374151',
            boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
            borderRadius: '12px',
            padding: '16px',
            fontSize: '14px',
            maxWidth: '400px',
          },
          success: { iconTheme: { primary: '#10b981', secondary: '#ffffff' } },
          error:   { iconTheme: { primary: '#ef4444', secondary: '#ffffff' } },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
